import React from 'react';
import {
  StyleSheet,
  View,
  Image,
  TouchableHighlight,
} from '../base_components';

import MenuOverlay from '../overlays/menu_overlay';

const styles = StyleSheet.create({
  menuButton: {
    position: 'absolute',
    top: '1em',
    left: '1em',
    width: '3em',
    height: '3em',
    flexDirection: 'column',
    overflow: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
  },
  highlight: {
    flex: 1,
    alignSelf: 'stretch',
    borderRadius: '0.3em',
    backgroundColor: 'rgba(0,0,0,0.2)',

    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    margin: '0.4em',
    flex: 1,
    alignSelf: 'stretch',
  },
});

const MENU_IMG = require('../../assets/img/menu_white.png');

export default class MenuButton extends React.PureComponent {
  _onPress = () => {
    MenuOverlay.open();
  };

  render() {
    const { style } = this.props;

    return (
      <View style={[styles.menuButton, style]}>
        <TouchableHighlight
          style={styles.highlight}
          underlayColor='blue'
          onPress={this._onPress}
        >
          <Image style={styles.icon} source={MENU_IMG} />
        </TouchableHighlight>
      </View>
    );
  }
}
